<template>
  <div>
    <amount-step
      v-if="step === 1"
      :vaultInfo="vaultInfo"
      :selectedAsset="selectedAsset"
      :balances="vaultBalancesState.result"
      :txPayload="txPayload"
      :isAssetReadonly="true"
      @next="setAmount"
      @selectAsset="setAsset"
    />
    <gas-option-step
      v-if="step === 2"
      :vaultInfo="vaultInfo"
      :selectedAsset="selectedAsset"
      :needApproveAccess="false"
      :txPayload="txPayload"
      :onNext="onNext"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { sleep, fetchEthereumTxStatus } from "@/common/lib/utils";
import AmountStep from "../withdraw/AmountStep.vue";
import GasOptionStep from "../withdraw/GasOptionStep.vue";

export default {
  components: {
    AmountStep,
    GasOptionStep,
  },
  data: () => ({
    selectedAsset: null,
    txPayload: {
      amount: 0,
    },
    step: 1,
  }),
  computed: {
    ...mapGetters({
      getVaultByIdentity: "projectConfig/getVaultByIdentity",
      projects: "projectConfig/projects",
      walletSelected: "userWallets/walletSelected",
      vaultBalancesState: "vaults/vaultBalances",
      isTxConfirmed: "notification/isTxConfirmed",
    }),
    vaultInfo() {
      const identity = this.selectedAsset?.identity || this.$route.params.vault;
      const theVault = this.getVaultByIdentity(identity);
      return {
        type: theVault.vaultType,
        token: theVault.coin,
        ...theVault,
      };
    },
    loadingData() {
      return this.vaultBalancesState.fetching;
    },
  },
  methods: {
    setProject() {
      this.$store.dispatch(
        "projectConfig/setCurrentProject",
        this.projects.find(p => p.name === "ethereum")
      );
    },
    setAsset(asset) {
      this.selectedAsset =
        asset || this.vaultInfo.tokens?.[0] || this.vaultInfo;
    },
    setAmount(amount, ratio) {
      this.txPayload.amount = amount;
      this.txPayload.ratio = ratio;
      this.step = 2;
    },
    async checkTxStatusEtherscan(txHash, retries = 0) {
      const result = await fetchEthereumTxStatus(txHash);
      if (!result.pending) {
        return result;
      }
      if (retries >= 20) {
        return {
          failed: true,
        };
      }
      await sleep(6000);
      return this.checkTxStatusEtherscan(txHash, retries);
    },
    async checkTxStatus(txHash, retries = 0) {
      if (this.isTxConfirmed(txHash)) {
        return {
          confirmed: true,
        };
      }
      if (retries >= 120) {
        return {
          failed: true,
        };
      }
      await sleep(1000);
      return this.checkTxStatus(txHash, retries + 1);
    },
    async onNext(txHash) {
      const { confirmed, failed } = await Promise.race([
        this.checkTxStatus(txHash),
        this.checkTxStatusEtherscan(txHash),
      ]);
      if (confirmed) {
        this.$store.dispatch("vaults/fetchBalances");
        this.$emit("onNext");
      } else if (failed) {
        this.$store.dispatch("addAlert", {
          type: "error",
          title: "Withdrawal failed",
          message:
            "Something went wrong. Please refresh the page and try again.",
        });
      }
    },
  },
  mounted() {
    this.setProject();
    this.setAsset();
  },
};
</script>
